module.exports = __webpack_public_path__ + "img/icon-youtube.b9c28b9e5a4b761977fdb57fa258f418.svg";